import React from 'react';

export const AddressDetails = () => {
    return (
        <div className="enquiry-section">
            {/* Hidden fields required by backend */}
            <input type="hidden" name="state" value="default" />
            <input type="hidden" name="pin" value={221505} />

            <div className="d-flex align-items-center gap-2 mb-2">
                <span className="section-title-badge bg-soft-info text-info">
                    <i className="ri-map-pin-line me-1"></i>Address Information
                </span>
            </div>

            <div className="row g-3">
                {/* Address textarea */}
                <div className="col-12 col-md-7">
                    <label htmlFor="address_1" className="form-label form-label-custom">
                        <i className="ri-home-4-line text-muted me-1"></i>
                        Full Address
                    </label>
                    <textarea
                        name="address_1"
                        id="address_1"
                        className="form-control form-control-custom"
                        rows={2}
                        placeholder="Enter detailed school/institute street address..."
                    ></textarea>
                </div>

                {/* District */}
                <div className="col-12 col-md-5">
                    <label htmlFor="district" className="form-label form-label-custom">
                        <i className="ri-building-2-line text-muted me-1"></i>
                        District / City
                    </label>
                    <input
                        type="text"
                        className="form-control form-control-custom"
                        id="district"
                        name="district"
                        placeholder="Enter District / City"
                    />
                </div>
            </div>
        </div>
    );
};

export default AddressDetails;
